




































































































import Vue from 'vue'
import { Component } from '@niknevis/vue-modules'
import { Prop } from 'vue-property-decorator'
import BaseButton from '@/modules/shared/components/shared/kit/BaseButton.vue'
import Modal from '@/modules/common/dialog/components/shared/Modal.vue'
import BaseSelect from '@/modules/shared/components/shared/kit/BaseSelect.vue'
import collect from 'collect.js'
import BaseInput from '@/modules/shared/components/shared/kit/BaseInput.vue'
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import { DateHelper } from '@/modules/shared/helpers/date'
import Toggle from '@/modules/shared/components/shared/kit/Toggle.vue'
import CurrencyInput from '@/modules/shared/components/shared/form/CurrencyInput.vue'
import { TicketResourceType } from '@/modules/ticket/models/ticket-resource.model'
import AdminDepartmentSearch from '@/modules/department/components/admin/AdminDepartmentSearch.vue'
import TesDatePicker from '@/modules/shared/components/shared/kit/TesDatePicker.vue'
import { TicketSettingUpdateUseCase } from '@/modules/ticket/use-cases/admin/ticket-setting-update.use-case'
import PersonSearch from '@/modules/common/person/components/PersonSearch.vue'

@Component({
  components: {
    PersonSearch,
    TesDatePicker,
    AdminDepartmentSearch,
    Toggle,
    BaseInput,
    BaseSelect,
    Modal,
    BaseButton,
    CurrencyInput
  }
})
export default class AdminTicketSetting extends Vue {
  @Prop() ticket: TicketResourceType
  @Prop({ default: 'تنظیمات' }) label: string
  dialogModel: boolean = false

  $refs!: {
    refLastAnswerDate: QPopupProxy,
  }

  constructor(
    private readonly dateHelper: DateHelper,
    private readonly ticketSettingUpdateUseCase: TicketSettingUpdateUseCase
  ) {
    super()
  }

  get ticketData() {
    return this.ticket.data
  }

  //methods
  get statusOptions() {
    return collect(this.ticket.statuses).map((item, index) => ({
      label: item,
      value: index
    })).toArray()
  }

  onSubmit() {
    this.ticketSettingUpdateUseCase.execute(this.ticketData.id, this.ticketData).then(() => {
      if (this.ticketSettingUpdateUseCase.isSuccess)
        this.dialogModel = false
    })
  }
}
